var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../styled';
import { mapResponsiveStyleValue } from '../utils/responsive-style-value';
export var gallerylayoutSizes = {
    small: 'repeat(auto-fill, minmax(150px, 1fr))',
    medium: 'repeat(auto-fill, minmax(250px, 1fr))',
    large: 'repeat(auto-fill, minmax(450px, 1fr))',
};
export var getValueForGalleryLayoutSize = function (size) {
    return size ? gallerylayoutSizes[size] : null;
};
export var Root = styled('ul', {
    name: 'QuantumGalleryLayout',
    slot: 'Root',
})({
    display: 'grid',
    listStyle: 'none',
    margin: 0,
    paddingLeft: 0,
});
export var GalleryLayout = React.forwardRef(function (_a, ref) {
    var component = _a.component, asProp = _a.as, _b = _a.gutter, gutter = _b === void 0 ? 3 : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, children = _a.children, sx = _a.sx, rootProps = __rest(_a, ["component", "as", "gutter", "size", "children", "sx"]);
    return (React.createElement(Root, __assign({ as: asProp || component || 'ul', ref: ref, sx: __assign({ display: 'grid', gridTemplateColumns: mapResponsiveStyleValue(size, getValueForGalleryLayoutSize), gap: gutter }, sx) }, rootProps), children));
});
